import React from 'react';

export const EmptyAccomplishments = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width="158"
    height="129"
    viewBox="0 0 158 129"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M121.057 28.6431L42.5792 107.121"
      stroke="#F4F4F7"
      strokeWidth="42"
      strokeLinecap="round"
    />
    <path
      d="M86.708 22.0352L35.5724 73.1708"
      stroke="#F4F4F7"
      strokeWidth="43"
      strokeLinecap="round"
    />
    <path
      d="M125.542 61.2744L74.4064 112.41"
      stroke="#F4F4F7"
      strokeWidth="32"
      strokeLinecap="round"
    />
    <path
      d="M107.2 123.91L104.371 126.751L102.617 124.997L105.446 122.168L102.617 119.34L104.371 117.585L107.2 120.427L110.029 117.585L111.783 119.34L108.942 122.168L111.783 124.997L110.029 126.751L107.2 123.91Z"
      fill="#EBEBF0"
    />
    <path
      d="M53.8838 11.665L51.055 14.5061L49.3009 12.752L52.1297 9.92323L49.3009 7.09444L51.055 5.34033L53.8838 8.18148L56.7126 5.34033L58.4667 7.09444L55.6256 9.92323L58.4667 12.752L56.7126 14.5061L53.8838 11.665Z"
      fill="#EBEBF0"
    />
    <circle cx="152.971" cy="40.4374" r="4.76012" fill="#EBEBF0" />
    <circle cx="8.64867" cy="104.037" r="2.38" fill="#EBEBF0" />
    <mask
      id="mask0_212_2898"
      maskUnits="userSpaceOnUse"
      x="111"
      y="80"
      width="34"
      height="33"
    >
      <rect
        x="111.783"
        y="80.1223"
        width="32.2877"
        height="32.2877"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_212_2898)">
      <path
        d="M128.6 96.199C129.25 95.4815 129.749 94.6631 130.097 93.7438C130.444 92.8245 130.618 91.8715 130.618 90.885C130.618 89.8984 130.444 88.9454 130.097 88.0261C129.749 87.1068 129.25 86.2884 128.6 85.5709C129.945 85.7503 131.066 86.3445 131.963 87.3535C132.86 88.3625 133.308 89.5396 133.308 90.885C133.308 92.2303 132.86 93.4074 131.963 94.4164C131.066 95.4254 129.945 96.0196 128.6 96.199ZM135.999 107.029V102.993C135.999 102.186 135.82 101.418 135.461 100.69C135.102 99.9605 134.631 99.3156 134.048 98.7551C135.192 99.1587 136.251 99.6798 137.227 100.318C138.202 100.958 138.69 101.849 138.69 102.993V107.029H135.999ZM138.69 97.6116V94.9209H135.999V92.2303H138.69V89.5396H141.38V92.2303H144.071V94.9209H141.38V97.6116H138.69ZM122.546 96.2662C121.066 96.2662 119.799 95.7393 118.745 94.6855C117.691 93.6316 117.164 92.3648 117.164 90.885C117.164 89.4051 117.691 88.1383 118.745 87.0844C119.799 86.0306 121.066 85.5037 122.546 85.5037C124.026 85.5037 125.292 86.0306 126.346 87.0844C127.4 88.1383 127.927 89.4051 127.927 90.885C127.927 92.3648 127.4 93.6316 126.346 94.6855C125.292 95.7393 124.026 96.2662 122.546 96.2662ZM111.783 107.029V103.262C111.783 102.5 111.979 101.799 112.372 101.159C112.764 100.521 113.285 100.033 113.936 99.6968C115.326 99.0017 116.738 98.4802 118.173 98.1322C119.608 97.7851 121.066 97.6116 122.546 97.6116C124.026 97.6116 125.483 97.7851 126.918 98.1322C128.353 98.4802 129.766 99.0017 131.156 99.6968C131.806 100.033 132.327 100.521 132.719 101.159C133.112 101.799 133.308 102.5 133.308 103.262V107.029H111.783ZM122.546 93.5756C123.286 93.5756 123.919 93.3119 124.447 92.7845C124.973 92.2581 125.236 91.6249 125.236 90.885C125.236 90.145 124.973 89.5118 124.447 88.9854C123.919 88.458 123.286 88.1943 122.546 88.1943C121.806 88.1943 121.173 88.458 120.646 88.9854C120.119 89.5118 119.855 90.145 119.855 90.885C119.855 91.6249 120.119 92.2581 120.646 92.7845C121.173 93.3119 121.806 93.5756 122.546 93.5756ZM114.474 104.338H130.618V103.262C130.618 103.015 130.556 102.791 130.433 102.589C130.31 102.387 130.147 102.231 129.945 102.118C128.734 101.513 127.512 101.059 126.279 100.756C125.046 100.453 123.801 100.302 122.546 100.302C121.29 100.302 120.046 100.453 118.812 100.756C117.579 101.059 116.357 101.513 115.146 102.118C114.945 102.231 114.782 102.387 114.659 102.589C114.536 102.791 114.474 103.015 114.474 103.262V104.338Z"
        fill="#BBB6F2"
      />
    </g>

    <g mask="url(#mask1_212_2898)">
      <path
        d="M38.6665 23.5V28.3333H44.9498L32.3831 40.7792L22.7165 31.1125L4.83313 49.1167L8.21646 52.5L22.7165 38L32.3831 47.6667L48.3331 31.7167V38H53.1665V23.5H38.6665Z"
        fill="#BBB6F2"
      />
    </g>

    <g mask="url(#mask2_212_2898)">
      <path
        d="M63.8752 35.2505H95.1252V59.7817C95.1252 60.9797 94.8648 62.0474 94.344 62.9849C93.8232 63.9224 93.094 64.6776 92.1565 65.2505L81.0627 71.813L83.2502 79.0005H95.1252L85.4377 85.8755L89.1877 97.7505L79.5002 90.4067L69.8127 97.7505L73.5627 85.8755L63.8752 79.0005H75.7502L77.9377 71.813L66.844 65.2505C65.9065 64.6776 65.1773 63.9224 64.6565 62.9849C64.1357 62.0474 63.8752 60.9797 63.8752 59.7817V35.2505ZM70.1252 41.5005V59.7817L76.3752 63.5317V41.5005H70.1252ZM88.8752 41.5005H82.6252V63.5317L88.8752 59.7817V41.5005Z"
        fill="#7D7A9A"
      />
    </g>
  </svg>
);
